.sectionHeader {
    display: flex;
    align-items: center;
    margin: 0.3rem 0;
}

.sectionHeader > :global(h3),
.sectionHeader > :global(h4),
.sectionHeader > :global(h5),
.sectionHeader > :global(h6) {
    margin: 0 !important;
}

.sectionHeader:hover {
    background-color: #f0f3fa;
    border-radius: 0.3rem;
    margin: 0.3rem -0.3rem;
    padding: 0 0.3rem;
}

.headerOptions {
    display: flex;
    margin-left: auto;
}

.buttonContainer {
    display: flex;
    flex-wrap: nowrap;
    flex-shrink: 0;
}

.iconButton {
    color: #1498b3;
    margin-left: 0.3rem;
    padding: 0.25rem;
    border-radius: 0.25rem;
    background: none;
    border: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.iconButton svg {
    height: 1rem;
    width: 1rem;
}

.iconButton:hover {
    background: rgba(0, 0, 0, 0.05);
}

.iconButton span {
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}

.augmentedContent {
    display: flex;
    flex-direction: row;
}

.augmentedContent .headerOptions {
    align-items: flex-start;
}

.augmentedContent .headerOptions .iconButton {
    box-sizing: border-box;
    height: 1.25rem;
    width: 1.25rem;
}

.contentContainer {
    flex: 1;
}
